import { render, staticRenderFns } from "./SVGFilter.vue?vue&type=template&id=760a3d22&scoped=true&"
import script from "./SVGFilter.vue?vue&type=script&lang=js&"
export * from "./SVGFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a3d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760a3d22')) {
      api.createRecord('760a3d22', component.options)
    } else {
      api.reload('760a3d22', component.options)
    }
    module.hot.accept("./SVGFilter.vue?vue&type=template&id=760a3d22&scoped=true&", function () {
      api.rerender('760a3d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGFilter.vue"
export default component.exports